module.exports = __webpack_public_path__ + "static/cover-7a38ed851300d83a185d07be0f737b2e.svg";